import { useRouter } from 'next/router';
import { useLang } from '@/i18n';
import EcoImg from 'eco-design-components/base/eco-img';
import EcoSpace from 'eco-design-components/base/eco-space';
import { useEffect, useState, useRef } from 'react';
import css from './index.module.scss';
import EFXCore3 from 'elem/ui-assets/icons/unregular/EFXCore3';
import EcoVideo from 'eco-design/base/eco-video';
import { ScrollMagicPluginGsap } from 'scrollmagic-plugin-gsap';
import ScrollMagicFn from '@/utils/ScrollMagic';
import { TweenMax, TimelineMax } from 'gsap';

interface EProps {
    loaded?: boolean;
}
let controllerE: any;
const E: React.FC<EProps> = () => {
    const { t } = useLang('rapidpro');
    const refAni = useRef<HTMLDivElement>(null);

    if (typeof window !== 'undefined') {
        if (!window?.ScrollMagic) {
            window.ScrollMagic = ScrollMagicFn();
            ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);
        }
    }

    const getTransDistancePC = () => {
        const tEl: HTMLDivElement | null = document.querySelector('.rapid-pro-E .l1');
        const bEl: HTMLDivElement | null = document.querySelector('.rapid-pro-E .l2-r-b');
        const lEl: HTMLDivElement | null = document.querySelector('.rapid-pro-E .l2-l');
        const rEl: HTMLDivElement | null = document.querySelector('.rapid-pro-E .l2-r-t-r');
        if (tEl && bEl && lEl && rEl) {
            const tH = tEl.offsetHeight || 0;
            const bH = bEl.offsetHeight || 0;
            const lW = lEl.offsetWidth || 0;
            const rW = rEl.offsetWidth || 0;
            return {
                x: (rW - lW) / 2,
                y: (bH - tH) / 2,
            };
        }
        return {
            x: 0,
            y: 0,
        };
    };

    const getTransDistanceH5 = () => {
        const l1El: HTMLDivElement | null = document.querySelector('.rapid-pro-E .r1');
        const l2El: HTMLDivElement | null = document.querySelector('.rapid-pro-E .r3');
        const l3El: HTMLDivElement | null = document.querySelector('.rapid-pro-E .r4');
        const l4El: HTMLDivElement | null = document.querySelector('.rapid-pro-E .r5');
        if (l1El && l2El && l3El && l4El) {
            const l1H = l1El.offsetHeight || 0;
            const l2H = l2El.offsetHeight || 0;
            const l3H = l3El.offsetHeight || 0;
            const l4H = l4El.offsetHeight || 0;
            return {
                x: 0,
                y: (-l2H + l3H + l4H - l1H) / 2,
            };
        }
        return {
            x: 0,
            y: 0,
        };
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const scrollFn = () => {
                const IS_PC = window.innerWidth >= 768;
                const IS_PAD = window.innerWidth <= 1024 && window.innerWidth >= 768;
                if (IS_PC) {
                    const target: HTMLDivElement | null = document.querySelector('.rapid-pro-E .l2-r-t-l');
                    const box: HTMLDivElement | null = document.querySelector('.rapid-pro-E .box');
                    const l: HTMLDivElement | null = document.querySelector('.rapid-pro-E .l2-l');
                    const b: HTMLDivElement | null = document.querySelector('.rapid-pro-E .l2-r-b');
                    const parent: HTMLDivElement | null = document.querySelector('.rapid-pro-E');
                    const { x, y } = getTransDistancePC();
                    if (target && box && l && b && parent) {
                        controllerE = new ScrollMagic.Controller();
                        const mini_pc = window.innerWidth > 1024 && window.innerHeight < 768;
                        const scene1 = new window.ScrollMagic.Scene({
                            triggerElement: '.rapid-pro-E',
                            triggerHook: 1,
                            offset: mini_pc ? window.innerHeight * 2 : window.innerHeight * 1.5,
                            duration: window.innerHeight,
                        });
                        const timeline = new TimelineMax();

                        const tweenTrans = TweenMax.fromTo(
                            '.rapid-pro-E .l2-r-t-l',
                            0.5,
                            { x: 0, y: 0 },
                            {
                                x,
                                y,
                            },
                        );

                        const tweenScale = TweenMax.fromTo(
                            '.rapid-pro-E .l2-r-t-l .ani-inner',
                            0.5,
                            {
                                width: '100%',
                                height: '100%',
                                top: '50%',
                            },
                            {
                                width: `${document.documentElement.clientWidth}px`,
                                height: `100vh`,
                                top: (_top, ele) => {
                                    const stickyTop = (window.innerHeight * 0.4 - 817) / 2;
                                    const { top } = ele.getBoundingClientRect();
                                    return mini_pc ? `calc(50% - ${(stickyTop + top) / 1.9}px)` : '50%';
                                },
                            },
                        );

                        const tweenLogo = TweenMax.fromTo(
                            '.rapid-pro-E .l2-r-t-l .x-core-3',
                            0.5,
                            {
                                width: IS_PAD ? 212.137 : 380,
                                height: IS_PAD ? 37.815 : 68,
                                translateY: 0,
                            },
                            {
                                width: IS_PAD ? 400 : 600,
                                height: IS_PAD ? 72 : 108,
                                translateY: -120,
                            },
                        );

                        const tweenText = TweenMax.fromTo(
                            '.rapid-pro-E .l2-r-t-l .box-info-desc',
                            0.5,
                            {
                                opacity: 0,
                            },
                            {
                                opacity: 1,
                            },
                        );

                        const hideTween = TweenMax.to(['.l2-l-b', '.l2-r-b'], 0, {
                            autoAlpha: 0,
                            immediateRender: false,
                        });

                        timeline.add(tweenTrans).add(tweenScale, 0).add(tweenLogo, 0).add(tweenText).add(hideTween);
                        scene1.setTween(timeline);
                        controllerE.addScene(scene1);
                    }
                } else {
                    const target: HTMLDivElement | null = document.querySelector('.rapid-pro-E .r2');
                    const box: HTMLDivElement | null = document.querySelector('.rapid-pro-E .box');
                    const r5: HTMLDivElement | null = document.querySelector('.rapid-pro-E .r5');
                    if (target && box && r5) {
                        controllerE = new ScrollMagic.Controller();
                        const scene1 = new window.ScrollMagic.Scene({
                            triggerElement: '.rapid-pro-E',
                            triggerHook: 1,
                            offset: window.innerHeight * 1.5,
                            duration: window.innerHeight,
                        });
                        const timeline = new TimelineMax();
                        const { x, y } = getTransDistanceH5();

                        const tweenTrans = TweenMax.fromTo(
                            '.rapid-pro-E .r2',
                            0.5,
                            { x: 0, y: 0 },
                            {
                                x,
                                y: y + window.innerHeight / 4,
                            },
                        );

                        const tweenScale = TweenMax.fromTo(
                            '.rapid-pro-E .r2 .ani-inner',
                            0.5,
                            {
                                width: '100%',
                                height: '100%',
                            },
                            {
                                width: window.innerWidth,
                                height: window.innerHeight,
                            },
                        );

                        const tweenLogo = TweenMax.fromTo(
                            '.rapid-pro-E .r2 .x-core-3',
                            0.5,
                            {
                                width: 200,
                                height: 36,
                            },
                            {
                                width: 300,
                                height: 54,
                            },
                        );

                        const tweenText = TweenMax.fromTo(
                            '.rapid-pro-E .r2 .box-info-desc',
                            0.5,
                            {
                                opacity: 0,
                                maxHeight: 0,
                                marginTop: 0,
                            },
                            {
                                maxHeight: 'unset',
                                marginTop: 6,
                                opacity: 1,
                            },
                        );

                        const tweenHide = TweenMax.fromTo(
                            '.rapid-pro-E .r5',
                            0.5,
                            {
                                opacity: 1,
                            },
                            {
                                opacity: 0,
                            },
                        );

                        timeline.add(tweenTrans).add(tweenScale, 0).add(tweenLogo, 0).add(tweenText, 0).add(tweenHide, 0);
                        scene1.setTween(timeline);
                        controllerE.addScene(scene1);
                    }
                }
            };
            scrollFn();
        }
    }, []);

    return (
        <div id="rapid-pro-E" className={`rapid-pro-E ${css.section}`}>
            <EcoSpace />
            <div className="info">
                <p className="info-title">{t('E_title')}</p>
            </div>
            <div className="box pc">
                <div className="l1 item">
                    <div className="box-img">
                        <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1748241799856/5_1.jpg" />
                    </div>
                    <div className="box-info">
                        <p className="box-info-title">{t('E_item1_title')}</p>
                        <p className="box-info-desc">{t('E_item1_desc')}</p>
                    </div>
                </div>
                <div className="l2">
                    <div className="l2-l">
                        <div className="l2-l-t item">
                            <div className="box-img">
                                <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1748241799329/5_2.jpg" />
                            </div>
                            <div className="box-info">
                                <p className="box-info-title">{t('E_item2_title')}</p>
                                <p className="box-info-desc">{t('E_item2_desc')}</p>
                            </div>
                        </div>
                        <div className="l2-l-b item">
                            <div className="box-img">
                                <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1748241800247/5_3.jpg" />
                            </div>
                            <div className="box-info">
                                <p className="box-info-title">{t('E_item3_title')}</p>
                                <p className="box-info-desc">{t('E_item3_desc')}</p>
                            </div>
                        </div>
                    </div>
                    <div className="l2-r">
                        <div className="l2-r-t">
                            <div className="l2-r-t-l item">
                                <div className="ani-inner" ref={refAni}>
                                    <div className="box-img">
                                        <EcoVideo
                                            autoPlay
                                            loop
                                            poster="https://websiteoss.ecoflow.com/upload/image/1748242089568/5_4.jpg"
                                            pc="https://websiteoss.ecoflow.com/upload/video/1750389352243/5_M.mp4"
                                        />
                                    </div>
                                    <div className="box-info">
                                        <EFXCore3 className="x-core-3" id="rapid_pro_E_pc" />
                                        <p className="box-info-desc">{t('E_desc')}</p>
                                    </div>
                                </div>
                            </div>
                            <div className="l2-r-t-r item">
                                <div className="box-img">
                                    <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1748241799544/5_5.jpg" />
                                </div>
                                <div className="box-info">
                                    <p className="box-info-title">{t('E_item5_title')}</p>
                                    <p className="box-info-desc">{t('E_item5_desc')}</p>
                                </div>
                            </div>
                        </div>
                        <div className="l2-r-b">
                            <div className="l2-r-b-l item">
                                <div className="box-img">
                                    <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1748241799682/5_6.jpg" />
                                </div>
                                <div className="box-info">
                                    <p className="box-info-desc">{t('E_item6_desc')}</p>
                                    <p className="box-info-title">{t('E_item6_title')}</p>
                                </div>
                            </div>
                            <div className="l2-r-b-r item">
                                <div className="box-img">
                                    <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1749624893733/5_7.jpg" />
                                </div>
                                <div className="box-info">
                                    <p className="box-info-title">{t('E_item7_title')}</p>
                                    <p className="box-info-desc">{t('E_item7_desc')}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {t('E_footer') && <div className="E_footer">{t('E_footer')}</div>}
                <EcoSpace />
            </div>
            <div className="box h5">
                <div className="r1 item">
                    <div className="box-img">
                        <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1748243809877/5_0_M.jpg" />
                    </div>
                    <div className="box-info">
                        <p className="box-info-title">{t('E_item1_title')}</p>
                        <p className="box-info-desc">{t('E_item1_desc')}</p>
                    </div>
                </div>
                <div className="r3 item">
                    <div className="box-img">
                        <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1750299225719/5_2_M.jpg" />
                    </div>
                    <div className="box-info">
                        <p className="box-info-title">{t('E_item5_title')}</p>
                        <p className="box-info-desc">{t('E_item5_desc')}</p>
                    </div>
                </div>
                <div className="r2 item">
                    <div className="ani-inner">
                        <div className="box-img">
                            <EcoVideo
                                autoPlay
                                loop
                                poster="https://websiteoss.ecoflow.com/upload/image/1748242089568/5_4.jpg"
                                pc="https://websiteoss.ecoflow.com/upload/video/1750389352243/5_M.mp4"
                            />
                        </div>
                        <div className="box-info">
                            <EFXCore3 className="x-core-3" id="rapid_pro_E_h5" />
                            <p className="box-info-desc">{t('E_desc')}</p>
                        </div>
                    </div>
                </div>
                <div className="r4">
                    <div className="r4-l item">
                        <div className="box-img">
                            <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1748243556018/5_4_M.jpg" />
                        </div>
                        <div className="box-info">
                            <p className="box-info-title">{t('E_item7_title')}</p>
                            <p className="box-info-desc">{t('E_item7_desc')}</p>
                        </div>
                    </div>
                    <div className="r4-r item">
                        <div className="box-img">
                            <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1748243636280/5_5_M.jpg" />
                        </div>
                        <div className="box-info">
                            <p className="box-info-title">{t('E_item2_title')}</p>
                            <p className="box-info-desc">{t('E_item2_desc')}</p>
                        </div>
                    </div>
                </div>
                <div className="r5">
                    <div className="r5-l item">
                        <div className="box-img">
                            <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1748243556186/5_6_M.jpg" />
                        </div>
                        <div className="box-info">
                            <p className="box-info-title">{t('E_item3_title')}</p>
                            <p className="box-info-desc">{t('E_item3_desc')}</p>
                        </div>
                    </div>
                    <div className="r5-r item">
                        <div className="box-img">
                            <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1748243636514/5_7_M.jpg" />
                        </div>
                        <div className="box-info">
                            <p className="box-info-desc">{t('E_item6_desc')}</p>
                            <p className="box-info-title">{t('E_item6_title')}</p>
                        </div>
                    </div>
                </div>

                {t('E_footer') && <div className="E_footer">{t('E_footer')}</div>}
                <EcoSpace />
            </div>
        </div>
    );
};

export default E;
